export enum ActionType {
  ShowOfferScreen = 'show_offer_screen',
  ShowExpiredApplicationScreen = 'show_expired_application_screen',
  ShowRejectionScreen = 'show_rejection_screen',
}
